import {scaffolderPlugin} from '@backstage/plugin-scaffolder';
import {createScaffolderFieldExtension} from '@backstage/plugin-scaffolder-react';
import {PrefixedInputField,} from './PrefixedInputFieldExtension.tsx';

export const PrefixedInputFieldExtension = scaffolderPlugin.provide(
    createScaffolderFieldExtension({
        name: 'PrefixedInputField',
        component: PrefixedInputField,
    }),
);
